import React from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionStyleContext from '../../main/contexts/ExpansionStyleContext';
import ErrorBoundary from './ErrorBoundary';


const CustomExpansionPanel = ({ title, shouldRender, render }) => {
  if (shouldRender) {
    return (
      <ErrorBoundary>
        <ExpansionStyleContext.Consumer>
          {classes => (
            <ExpansionPanel>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.heading}>{title}</Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                {render()}
              </ExpansionPanelDetails>
            </ExpansionPanel>
          )}
        </ExpansionStyleContext.Consumer>
      </ErrorBoundary>
    );
  }
  return null;
}

export default CustomExpansionPanel;


// WEBPACK FOOTER //
// ./src/commons/components/CustomExpansionPanel.jsx